import type { ReviewOutputDataT } from '../../common/review-mode-side-panel';
import type { AnnotationLabelT, BaseInputDataT, BaseOutputLabelledDataT, GenericAnnotationReviewDataT, LabellingValidationsT } from '../../common/types/types';
import type { MediaItemT } from '../types';
import type { EntityTaggingAnnotationT } from './annotation.type';
export type OutputAnnotationT = Omit<EntityTaggingAnnotationT, 'annotationLabel'> & {
  annotationLabel: Omit<AnnotationLabelT, 'style'>;
  id: string;
};
export type OutputDataT = {
  mediaUrl: string;
  annotations: OutputAnnotationT[];
};
export type MEDIA_TYPET = 'AUDIO' | 'VIDEO' | undefined | null;
export type InputDataT = {
  mediaUrl: string;
  mediaType: MEDIA_TYPET;
  annotations: OutputAnnotationT[];
  reviewData: GenericAnnotationReviewDataT[];
  feedbackData?: ReviewOutputDataT;
  minLength?: number | null;
  maxLength?: number | null;
  skipFrameTime?: number;
  frameRate?: number;
  multiMediaList: MediaItemT[];
  hideNoEntityCheckbox?: boolean;
  mediaPlaybackTracking?: boolean[];
  waveformPeaks?: number[];
  mediaFileReference?: string;
} & BaseInputDataT;
export type OutputLabelledDataT = {
  labellingType: 'ENTITY_TAGGING';
  mediaUrl: string;
  mediaType: MEDIA_TYPET;
  annotations: OutputAnnotationT[];
  reviewData: GenericAnnotationReviewDataT[];
  feedbackData?: ReviewOutputDataT;
  minLength?: number | null;
  maxLength?: number | null;
  skipFrameTime?: number;
  frameRate?: number;
  multiMediaList: MediaItemT[];
  mediaPlaybackTracking?: boolean[];
  waveformPeaks?: number[];
} & BaseOutputLabelledDataT;
export type OutputLabellingValidationsT = {
  containsPendingItem: boolean;
  containsRejectedAnnotation: boolean;
  hasUnplayedAudioSegments?: boolean;
} & LabellingValidationsT;
export type onStoreChangeT = (outputLabelledData: OutputLabelledDataT, validations: OutputLabellingValidationsT) => void;